import { DashboardUi } from "..";
import { Box, Tab, Tabs } from "@mui/material";
import { StaffSales } from "./StaffSales";
import { useLocation, useNavigate } from "react-router-dom";
import { TabContextProvider } from "../../../store";
import { TabPanel } from "../../../shared";

export const DashboardContainer = () => {
  const { pathname } = useLocation();
  const { search } = useLocation();
  const navigate = useNavigate();
  const isStoreAdmin = pathname.includes("store-admin");


  const handleChange = (event, newValue) => {
    navigate({
      pathname: isStoreAdmin ? "/store-admin" : "",
      search: newValue,
    });
  };

  return (
    <>
     
        <Box
          className="sticky-Tab no-margin"
          sx={{ borderBottom: 1, borderColor: "divider", top: "64px" }}
        >
          <Tabs value={search} onChange={handleChange}>
            <Tab label="Dashboard" value="" />
            {isStoreAdmin && <Tab label="Staff Sales" value="?staffSales" />}
          </Tabs>
        </Box>

         <TabContextProvider value={search}>
        <TabPanel sx={{ p: "16px 32px" }} value="">
          <DashboardUi />
        </TabPanel>
        <TabPanel sx={{ p: "16px 32px" }} value="?staffSales">
          {isStoreAdmin && <StaffSales />}
        </TabPanel>
      </TabContextProvider>
    </>
  );
};
